import { render } from "./MultipleAttributesStep.vue?vue&type=template&id=5a1a61fc"
import script from "./MultipleAttributesStep.vue?vue&type=script&lang=js"
export * from "./MultipleAttributesStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__